import { __awaiter, __generator } from "tslib";
import { fetchSiteSetting } from './http/fetch-site-setting';
/** Fetches `myjabra` setting from site settings. */
export var fetchMyJabraSetting = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchSiteSetting("myjabra" /* MyJabra */)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
